import type React from 'react';

export async function handleHtmlContentLinkClick(
    event: React.MouseEvent<HTMLDivElement>,
    onLinkClick?: (url: string) => void | Promise<void>,
): Promise<void> {
    const anchor = (event.target as HTMLElement).closest?.('a');
    if (!anchor || !(anchor instanceof HTMLAnchorElement)) return;

    const href = anchor.href;
    if (!href) return;

    if (!onLinkClick) return;

    event.preventDefault();
    event.stopPropagation();
    await onLinkClick(href);
    const target = anchor.target?.toLowerCase();
    if (target === '_blank') {
        window.open(href, '_blank', 'noopener,noreferrer');
    } else {
        window.location.href = href;
    }
}
